import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { CookieService } from 'ngx-cookie-service';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ToastrModule } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AngularFireFunctionsModule } from '@angular/fire/functions';

import { environment } from '../environments/environment';
import { ChatComponent } from './support/chat/chat.component';
import { HomeComponent } from './home/home.component';
import { TopComponent } from './top/top.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './navigation/header/header.component';
import { FooterComponent } from './navigation/footer/footer.component';
import { MenuComponent } from './navigation/menu/menu.component';
import { LoginComponent } from "./auth/login/login.component";
import { RegisterComponent } from "./auth/register/register.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PasswordComponent } from "./auth/password/password.component";
import { PrivacyComponent } from "./static/privacy/privacy.component";
import { TermsComponent } from "./static/terms/terms.component";
import { ProfileComponent } from "./settings/profile/profile.component";
import { ChatRoomComponent } from './support/room/room.component';
import { SupportHistoryComponent } from './support/history/history.component';
import { AvatarCallComponent } from './avatar/call/call.component';
import { ReserveListComponent } from './reserve/list/list.component';
import { ReserveCancelComponent } from './reserve/cancel/cancel.component';
import { NewsComponent } from './static/news/news.component';
import { CallTestComponent } from './avatar/call-test/call-test.component';

// Normal User
import { SupportIndexComponent } from "./support/index/index.component";
import { SupportCardComponent } from "./support/card/card.component";
import { SupportVtuberInfoComponent } from "./support/card/info/info.component";
import { SupportCardRegisterComponent } from "./support/card/register/register.component";
import { SupportPayComponent } from "./support/card/pay/pay.component";
import { SettingCardComponent } from "./settings/card/card.component";
import { SupportPlansComponent } from './support/plans/plans.component';
import { SupportPlanItemComponent } from './support/plans/item/item.component';
import { SettingCardDetailComponent } from './settings/card-detail/card-detail.component';
import { SupportVtubersComponent } from './support/vtubers/vtubers.component';
import { ReserveAddComponent } from './reserve/add/add.component';
import { ReserveConfirmComponent } from './reserve/confirm/confirm.component';

// VTuber
import { VTuberRegisterComponent } from "./vtuber/auth/register/register.component";
import { VTuberHomeComponent } from './vtuber/home/home.component';
import { VTuberProfileComponent } from './vtuber/profile/profile.component';
import { VTuberSupportCreateComponent } from './vtuber/support/create/create.component';
import { FormProfileComponent } from "./vtuber/support/forms/profile/profile.component";
import { FormPlanComponent } from "./vtuber/support/forms/plan/plan.component";
import { FormPlanAddComponent } from "./vtuber/support/forms/plan/add/add.component";
import { FormPlanWelcomeComponent } from "./vtuber/support/forms/welcome/welcome.component";
import { FormBankComponent } from './vtuber/support/forms/bank/bank.component';
import { VTuberSupportPreviewComponent } from './vtuber/support/preview/preview.component';
import { VtuberNotificationComponent } from './vtuber/notification/notification.component';
import { VTuberCallTimesComponent } from './vtuber/call/times/times.component';
import { VTuberSupportersComponent } from "./vtuber/support/list/list.component";
import { VTuberHistoryComponent } from "./vtuber/history/history.component";
import { VTuberBankComponent } from './vtuber/profile/bank/bank.component';
import { VTuberBankEditComponent } from './vtuber/profile/bank/edit/edit.component';
import { AvatarSelectComponent } from './avatar/select/select.component';
import { AvatarConfirmComponent } from './avatar/confirm/confirm.component';
import { NotificationComponent } from './support/notification/notification.component';
import { LawComponent } from './static/law/law.component';
import { MaintenanceComponent } from './static/maintenance/maintenance.component';

// const config = {
//   apiKey: "AIzaSyAIlowQ5DIZ-qHdfmBKE65JP3tJUK1p_14",
//   authDomain: "laer-39ee6.firebaseapp.com",
//   databaseURL: "https://laer-39ee6.firebaseio.com",
//   projectId: "laer-39ee6",
//   storageBucket: "laer-39ee6.appspot.com",
//   messagingSenderId: "934412461250",
//   appId: "1:934412461250:web:2ce3b9f5b2e90fc48d475b",
//   measurementId: "G-NJZX52FB4L"
// };
const config = environment.firebase

@NgModule({
  declarations: [
    AppComponent,
    ChatComponent,
    HomeComponent,
    TopComponent,
    LayoutComponent,
    HeaderComponent,
    MenuComponent,
    LoginComponent,
    RegisterComponent,
    PasswordComponent,
    PrivacyComponent,
    TermsComponent,
    ProfileComponent,
    FooterComponent,
    VTuberRegisterComponent,
    VTuberHomeComponent,
    VTuberProfileComponent,
    VTuberSupportCreateComponent,
    FormProfileComponent,
    FormPlanComponent,
    FormPlanAddComponent,
    FormPlanWelcomeComponent,
    FormBankComponent,
    VTuberSupportPreviewComponent,
    SupportIndexComponent,
    SupportCardComponent,
    SupportVtuberInfoComponent,
    SupportCardRegisterComponent,
    SupportPayComponent,
    SettingCardComponent,
    ChatRoomComponent,
    SupportPlansComponent,
    SupportPlanItemComponent,
    SupportHistoryComponent,
    SettingCardDetailComponent,
    SupportVtubersComponent,
    VtuberNotificationComponent,
    VTuberCallTimesComponent,
    VTuberSupportersComponent,
    VTuberHistoryComponent,
    VTuberBankComponent,
    VTuberBankEditComponent,
    AvatarSelectComponent,
    AvatarCallComponent,
    AvatarConfirmComponent,
    ReserveAddComponent,
    ReserveConfirmComponent,
    ReserveListComponent,
    ReserveCancelComponent,
    NotificationComponent,
    NewsComponent,
    CallTestComponent,
    LawComponent,
    MaintenanceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AngularFireModule.initializeApp(config),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    NgbModule,
    FullCalendarModule,
    ToastrModule.forRoot(),
    MatProgressSpinnerModule,
    MatIconModule,
    MatSnackBarModule,
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule {}
